import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { getVisited } from "../../store/selectors/provider";
import {
  getCenter,
  getAddress,
  getMapLocations,
  getOnlineResults,
  getMetaData,
  isLoading,
  getTerm,
  getFlexibleLocation,
  getListView,
  getFilters,
} from "../../store/selectors/search";
import {
  changeAddress,
  searchMapResults,
  clearAddress,
  changeListView,
  clearSearch,
  setFilters,
  setFilter,
} from "../../store/actions/search";

import SearchMap from "./SearchMap";

const mapStateToProps = state => ({
  visitedProviders: getVisited(state),
  center: getCenter(state),
  address: getAddress(state),
  results: getMapLocations(state),
  onlineResults: getOnlineResults(state),
  metadata: getMetaData(state),
  term: getTerm(state),
  isLoading: isLoading(state),
  flexibleLocation: getFlexibleLocation(state),
  listView: getListView(state),
  filters: getFilters(state),
});

const mapDispatchToProps = {
  clearAddress,
  changeAddress,
  searchMapResults,
  changeListView,
  clearSearch,
  setFilters,
  setFilter,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SearchMap));
